// extracted by css-extract-rspack-plugin
module.exports =  {"six_col_layout":"D3GmJ","subsection_spacing":"Kf_Zz","nonGrid":"LzH1w","cards":"ZSnCE","leadplusText":"PMtQ2","fontBold":"hDVTu","shopping_destination":"DQHcn"};